import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTarget } = FiIcons;

const Hero = () => {
  return (
    <section className="bg-gradient-to-r from-[#FF5F1F] to-orange-600 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <SafeIcon icon={FiTarget} className="w-16 h-16 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            VMC Monastery Fundraising Campaign
          </h1>
          <p className="text-xl md:text-2xl opacity-90 mb-8">
            Seven-Month Strategic Campaign Proposal
          </p>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 max-w-2xl mx-auto">
            <h2 className="text-2xl font-semibold mb-2">Campaign Goal</h2>
            <p className="text-3xl font-bold text-yellow-300">$19M Target</p>
            <p className="text-sm opacity-80 mt-2">by 15 Mar 2026 (with ~$500k cushion for overrun or maintenance fund)</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;